import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Måste jag tillverka själv för att få gårdsförsäljning?";
const SHORT_ANSWER = "Ja. Endast produkter tillverkade på själva anläggningen får säljas via gårdsförsäljningstillstånd.";

export const Route = createFileRoute("/fraga/behover-jag-egen-tillverkning")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Måste jag tillverka själv för att få gårdsförsä…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Detta skiljer gårdsförsäljningen från traditionell butiksförsäljning. Du får inte komplettera ditt sortiment med importerade eller inköpta produkter."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning", label: "Gårdsförsäljning – komplett hubb" }}
      related={[{"to": "/fraga/far-vingard-salja-via-natet", "label": "Får en vingård sälja vin via nätet under gårdsförsäljningsreglerna?"}, {"to": "/fraga/vilka-volymregler-galler-for-mikrobryggeri", "label": "Vilka volymregler gäller för mikrobryggeri vid gårdsförsäljning?"}, {"to": "/fraga/hur-mycket-far-jag-salja-per-besokare", "label": "Hur mycket alkohol får jag sälja per besökare vid gårdsförsäljning?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Måste jag tillverka själv för att få gårdsförsäljning?" },
      { name: "description", content: "Ja. Endast produkter tillverkade på själva anläggningen får säljas via gårdsförsäljningstillstånd." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/behover-jag-egen-tillverkning" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/behover-jag-egen-tillverkning" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/behover-jag-egen-tillverkning",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Måste jag tillverka själv för att få gårdsförsä…", url: "https://alkoholprovet.se/fraga/behover-jag-egen-tillverkning" },
      ]),
    ],
  }),
});
